<template>
  <div>

    <loader v-if="loader"/>

    <div v-else>
      <card-with-aside
          class="px-5 py-3"
          :title="$t('transactions.transaction_info.label')"
          :asideLeftWidth="0">
        <template slot="body">
          <object-representation
              :entity="transactionInfoObj"
          />
          <div v-if="!isObjectEmpty(transactionInfoObj)">
            <b-btn
                :id="'transaction_copy_button'"
                @click="copyDataToClipboard(JSON.stringify(transactionInfoObj, null, 4), true)"
                class="align-self-end btn-width w-300 input-height ml-2 mt-4">
              {{ $t('transactions.transaction_info.copy_button') }}
            </b-btn>
            <b-tooltip
                :target="`transaction_copy_button`"
                triggers="focus"
                :title="$t('transactions.transaction_info.transaction_info_copied')"
                placement="topright"
                :delay="{show: 0, hide: 800}"
            ></b-tooltip>
          </div>
        </template>
      </card-with-aside>
    </div>
  </div>
</template>

<script>
import objectRepresentation from '@/components/global/objectRepresentation';
import {inviteMethods} from '@/mixins/invite';
import {isEmpty} from 'lodash';

export default {
  name: "TransactionInfo.vue",
  components: {objectRepresentation},
  mixins: [inviteMethods],
  data() {
    return {
      transactionInfoObj: {},
      loader: false,
    }
  },
  created () {
    this.getTransactionInfo();
  },
  computed: {
    id() {
      return this.$route.params.id || '';
    },
  },
  methods: {
    async getTransactionInfo () {
      this.loader = true;
      this.getData(`/transactions/${this.id}`, {}, true, false).then(({data}) => {
        if (data) {
          this.transactionInfoObj = this.clearExtraFields(data);
        }
      }).catch((error) => {
        if (error) {
          console.log('ERROR: ', error);
        }
      }).finally(() => {
        this.loader = false;
      });
    },
    clearExtraFields (data) {
      const extraFields = ['executed_time', 'memory_peak', 'server', 'req_guid'];
      extraFields.forEach((field) => {
        if (data.hasOwnProperty(field)) {
          delete data[field];
        }
      })
      return data;
    },
    isObjectEmpty(obj) {
      return isEmpty(obj);
    }
  }
}
</script>